import * as Sentry from '@sentry/browser';
import { DataCapsule, FrameStorageStrategy } from 'data-capsule';
import wix from './wix';
import { KEY_PREFIX } from '../constants/visit-count-key';

export const initVisitCount = () => {
  const instanceId = wix.getInstanceId();
  const key = `${KEY_PREFIX}-${instanceId}`;

  const capsule = new DataCapsule({
    strategy: new FrameStorageStrategy(window.top, '*', wix.getCompId()),
    namespace: 'wix',
  });

  const getVisitObj = async (): Promise<{
    visitCount: number;
    lastUpdate?: any;
  }> => {
    try {
      return await capsule.getItem(key);
    } catch (e) {
      // not found
      // migration
      try {
        const localStorageVal = window.localStorage.getItem(key);

        if (localStorageVal) {
          const { numVisits: visitCount, lastVisit: lastUpdate } = JSON.parse(
            localStorageVal,
          );
          return { visitCount, lastUpdate };
        }

        return { visitCount: 0 };
      } catch (e) {
        return { visitCount: 0 };
      }
    }
  };

  const getVisitCount = async () => {
    const { visitCount } = await getVisitObj();
    return visitCount;
  };

  function getTodayDate() {
    const currentTime = Date.now();
    return new Date(currentTime).toISOString().substring(0, 10);
  }

  const incVisitCount = async () => {
    const todayDate = getTodayDate();
    const { visitCount, lastUpdate } = await getVisitObj();
    if (lastUpdate !== todayDate) {
      const newCount = visitCount + 1;
      try {
        await capsule.setItem(key, {
          visitCount: newCount,
          lastUpdate: todayDate,
        });
      } catch (e) {
        Sentry.captureException(e);
      }
    }
  };

  return {
    getVisitCount,
    incVisitCount,
  };
};
